  export const LOG_TYPES = {
    INFO: "info",
    ERROR: "error",
    WARN: "warn"
  };

